import { defineMessages } from 'react-intl';

const translationsComponents = defineMessages({
  TIRE_N_WHEEL: {
    id: 'TIRE_N_WHEEL',
    defaultMessage: `tires and wheels`,
  },
  ADD_PHOTOS_LITE_CAPTIONS_2: {
    id: 'ADD_PHOTOS_LITE_CAPTIONS_2',
    defaultMessage: `add photos`,
  },
  ADD_PHOTOS_LITE_CAPTIONS_3: {
    id: 'ADD_PHOTOS_LITE_CAPTIONS_3',
    defaultMessage: `confirm capture`,
  },
  VIN_OUTLINE_CAPTIONS: {
    id: 'VIN_OUTLINE_CAPTIONS',
    defaultMessage: `make sure your vehicle's vin is visible in your photo`,
  },
  CONFIRM_DAMAGE_INSTRUCTION_MESS: {
    id: 'CONFIRM_DAMAGE_INSTRUCTION_MESS',
    defaultMessage: `Carefully review the damages that PAVE detected and accept or deny each one as you feel fit.`,
  },
  CONFIRM_DAMAGE_CAPTION: {
    id: 'CONFIRM_DAMAGE_CAPTION',
    defaultMessage: `Confirm Damage`,
  },
  CONFIRM_DAMAGE_COMPNENT: {
    id: 'CONFIRM_DAMAGE_COMPNENT',
    defaultMessage: `Component`,
  },
  PAVE_DAMS_GROUP_TITLE_SUB_4: {
    id: 'PAVE_DAMS_GROUP_TITLE_SUB_4',
    defaultMessage: `damage type`,
  },
  PAVE_DAMS_GROUP_TITLE_SUB_6: {
    id: 'PAVE_DAMS_GROUP_TITLE_SUB_6',
    defaultMessage: `repair method`,
  },
  CONFIRM_DAMAGE_DESCRIPTION: {
    id: 'CONFIRM_DAMAGE_DESCRIPTION',
    defaultMessage: `description`,
  },
  VIN_DECODE_CAPTURE_BTN: {
    id: 'VIN_DECODE_CAPTURE_BTN',
    defaultMessage: `capture`,
  },
  CAPTURE_VIHICLE_2: {
    id: 'CAPTURE_VIHICLE_2',
    defaultMessage: `Vehicle`,
  },
  BTN_PHOTO_REVIEW_APPROVE: {
    id: 'BTN_PHOTO_REVIEW_APPROVE',
    defaultMessage: `Approve`,
  },
  APPROVE_INSPECTION_2: {
    id: 'APPROVE_INSPECTION_2',
    defaultMessage: `Review Inspection`,
  },
  PROCESSING_INSPECTION_CAPTION: {
    id: 'PROCESSING_INSPECTION_CAPTION',
    defaultMessage: `processing inspection`,
  },
  PROCESSING_PHOTO_QC_CAPTION: {
    id: 'PROCESSING_PHOTO_QC_CAPTION',
    defaultMessage: `processing photo approval`,
  },
  PROCESSING_PHOTO_QC_DESCRIPTION: {
    id: 'PROCESSING_PHOTO_QC_DESCRIPTION',
    defaultMessage: `{number} photos left`,
  },
  FINALIZING_INSPECTION_CAPTION: {
    id: 'FINALIZING_INSPECTION_CAPTION',
    defaultMessage: `finalizing inspection`,
  },
  FINALIZING_INSPECTION_CAPTION_LITE: {
    id: 'FINALIZING_INSPECTION_CAPTION_LITE',
    defaultMessage: `finalizing session`,
  },
  NOTIFY_ME: {
    id: 'NOTIFY_ME',
    defaultMessage: `Notify Me`,
  },
  ADD_IMAGES: {
    id: 'ADD_IMAGES',
    defaultMessage: `Add Images`,
  },
  APPROXIMATING_COUNTDOWN: {
    id: 'APPROXIMATING_COUNTDOWN',
    defaultMessage: `Approximately`,
  },
  REMAINING_COUNTDOWN: {
    id: 'REMAINING_COUNTDOWN',
    defaultMessage: `remaining`,
  },
  BTN_PHOTO_REVIEW_RETAKE: {
    id: 'BTN_PHOTO_REVIEW_RETAKE',
    defaultMessage: `Retake`,
  },
  REVIEW_PHOTO_ALREADY_TAKEN: {
    id: 'REVIEW_PHOTO_ALREADY_TAKEN',
    defaultMessage: `Photo has already been accepted.`,
  },
  REVIEW_PHOTO_TOUCH_TO_CANCEL: {
    id: 'REVIEW_PHOTO_TOUCH_TO_CANCEL',
    defaultMessage: `Touch anywhere to cancel auto advance feature.`,
  },
  CAM_LAYOUT_MESSAGE_INSTRUCTIONS_1: {
    id: 'CAM_LAYOUT_MESSAGE_INSTRUCTIONS_1',
    defaultMessage:
      "Open the drivers' door to locate the plate that contains the vehicle identification number/VIN and click the green camera to take a photo within these lines. Please make sure the VIN itself is readable in your image.",
  },
  CAM_LAYOUT_MESSAGE_INSTRUCTIONS_2: {
    id: 'CAM_LAYOUT_MESSAGE_INSTRUCTIONS_2',
    defaultMessage: `Standing looking through the open driver's door, take a photo of the interior as illustrated by these lines.`,
  },
  CAM_LAYOUT_MESSAGE_INSTRUCTIONS_3: {
    id: 'CAM_LAYOUT_MESSAGE_INSTRUCTIONS_3',
    defaultMessage: `Start the vehicle and capture the instrument cluster according to this illustration with the odometer reading displayed. Before exiting the vehicle, please turn the steering wheel as far to the left as it will go.`,
  },
  CAM_LAYOUT_MESSAGE_INSTRUCTIONS_3_RHD: {
    id: 'CAM_LAYOUT_MESSAGE_INSTRUCTIONS_3_RHD',
    defaultMessage: `Start the vehicle's engine and capture the instrument cluster according to this illustration. Before exiting the vehicle please turn the steering wheel as far right as it will go.`,
  },
  CAM_LAYOUT_MESSAGE_INSTRUCTIONS_3_LITE: {
    id: 'CAM_LAYOUT_MESSAGE_INSTRUCTIONS_3_LITE',
    defaultMessage: `Start the vehicle and capture the instrument cluster according to this illustration with the odometer reading displayed. `,
  },
  CAM_LAYOUT_MESSAGE_INSTRUCTIONS_4: {
    id: 'CAM_LAYOUT_MESSAGE_INSTRUCTIONS_4',
    defaultMessage: `As shown in this illustration, close the driver's door and safely step back about 10 feet to align yourself within the driver side profile. Please fit the vehicle within these lines.`,
  },
  CAM_LAYOUT_MESSAGE_INSTRUCTIONS_4_RHD: {
    id: 'CAM_LAYOUT_MESSAGE_INSTRUCTIONS_4',
    defaultMessage: `Align the vehicle's left side profile according to this illustration. Please fit the vehicle within these lines.`,
  },
  CAM_LAYOUT_MESSAGE_INSTRUCTIONS_4_UK: {
    id: 'CAM_LAYOUT_MESSAGE_INSTRUCTIONS_4_UK',
    defaultMessage: `As shown in this illustration, align yourself within the passenger side profile by stepping back about 10 feet to. Please fit the vehicle within these lines.`,
  },
  CAM_LAYOUT_MESSAGE_INSTRUCTIONS_5: {
    id: 'CAM_LAYOUT_MESSAGE_INSTRUCTIONS_5',
    defaultMessage: `Next, move closer to the vehicle and fill your camera frame at a 45-degree angle of the front driver side, as shown in this illustration.`,
  },
  CAM_LAYOUT_MESSAGE_INSTRUCTIONS_5_UK: {
    id: 'CAM_LAYOUT_MESSAGE_INSTRUCTIONS_5_UK',
    defaultMessage: `Next, move closer to the vehicle and fill your camera frame at a 45-degree angle of the front passenger side, as shown in this illustration.`,
  },
  CAM_LAYOUT_MESSAGE_INSTRUCTIONS_6: {
    id: 'CAM_LAYOUT_MESSAGE_INSTRUCTIONS_6',
    defaultMessage: `Move to the front of the vehicle, stepping back safely about 10 feet to capture the profile according to this illustration. Please fit the vehicle within these lines.`,
  },
  CAM_LAYOUT_MESSAGE_INSTRUCTIONS_7: {
    id: 'CAM_LAYOUT_MESSAGE_INSTRUCTIONS_7',
    defaultMessage: `Next, move closer to the vehicle and fill your camera frame at a 45-degree angle of the front passenger side, as shown in this illustration.`,
  },
  CAM_LAYOUT_MESSAGE_INSTRUCTIONS_7_UK: {
    id: 'CAM_LAYOUT_MESSAGE_INSTRUCTIONS_7_UK',
    defaultMessage: `Next, move closer to the vehicle and fill your camera frame at a 45-degree angle of the front driver side, as shown in this illustration.`,
  },
  CAM_LAYOUT_MESSAGE_INSTRUCTIONS_8: {
    id: 'CAM_LAYOUT_MESSAGE_INSTRUCTIONS_8',
    defaultMessage: `As shown in this illustration, close the passenger door and safely step back about 10 feet to align yourself within the passenger side profile. Please fit the vehicle within these lines.`,
  },
  CAM_LAYOUT_MESSAGE_INSTRUCTIONS_8_UK: {
    id: 'CAM_LAYOUT_MESSAGE_INSTRUCTIONS_8_UK',
    defaultMessage: `As shown in this illustration, close the driver's door and safely step back about 10 feet to align yourself within the driver side profile. Please fit the vehicle within these lines.`,
  },
  CAM_LAYOUT_MESSAGE_INSTRUCTIONS_9: {
    id: 'CAM_LAYOUT_MESSAGE_INSTRUCTIONS_9',
    defaultMessage: `Next, move closer to the vehicle and fill your camera frame at a 45-degree angle of the rear passenger side, as shown in this illustration.`,
  },
  CAM_LAYOUT_MESSAGE_INSTRUCTIONS_9_UK: {
    id: 'CAM_LAYOUT_MESSAGE_INSTRUCTIONS_9_UK',
    defaultMessage: `Next, move closer to the vehicle and fill your camera frame at a 45-degree angle of the rear driver side, as shown in this illustration.`,
  },
  CAM_LAYOUT_MESSAGE_INSTRUCTIONS_10: {
    id: 'CAM_LAYOUT_MESSAGE_INSTRUCTIONS_10',
    defaultMessage: `Move to the rear of the vehicle and capture the profile according to this illustration. Please try and fit the outline of the vehicle within these lines.`,
  },
  CAM_LAYOUT_MESSAGE_INSTRUCTIONS_11: {
    id: 'CAM_LAYOUT_MESSAGE_INSTRUCTIONS_11',
    defaultMessage: `Next, move closer to the vehicle and fill your camera frame at a 45-degree angle of the rear left side, as shown in this illustration.`,
  },
  CAM_LAYOUT_MESSAGE_INSTRUCTIONS_11_UK: {
    id: 'CAM_LAYOUT_MESSAGE_INSTRUCTIONS_11_UK',
    defaultMessage: `Next, move closer to the vehicle and fill your camera frame at a 45-degree angle of the rear passenger side
    , as shown in this illustration.`,
  },
  CAM_LAYOUT_MESSAGE_INSTRUCTIONS_12: {
    id: 'CAM_LAYOUT_MESSAGE_INSTRUCTIONS_12',
    defaultMessage: `Move close to the windshield and capture it according to this illustration. Please fit the windshield within these lines.`,
  },
  CAM_LAYOUT_MESSAGE_INSTRUCTIONS_13: {
    id: 'CAM_LAYOUT_MESSAGE_INSTRUCTIONS_13',
    defaultMessage: `Move to the front right tire and capture the tire's profile according to this illustration.`,
  },
  CAM_LAYOUT_MESSAGE_INSTRUCTIONS_13_UK: {
    id: 'CAM_LAYOUT_MESSAGE_INSTRUCTIONS_13_UK',
    defaultMessage: `Move to the front driver tire and capture the tire's profile according to this illustration.`,
  },
  CAM_LAYOUT_MESSAGE_INSTRUCTIONS_15: {
    id: 'CAM_LAYOUT_MESSAGE_INSTRUCTIONS_15',
    defaultMessage: `Move to the rear driver's side tire and capture the tread, as shown in this illustration.`,
  },
  CAM_LAYOUT_MESSAGE_INSTRUCTIONS_15_RHD: {
    id: 'CAM_LAYOUT_MESSAGE_INSTRUCTIONS_15_RHD',
    defaultMessage: `Move to the rear passenger's side tire and capture the tread, as shown in this illustration.`,
  },
  CAM_LAYOUT_BTN_CANCEL: {
    id: 'CAM_LAYOUT_BTN_CANCEL',
    defaultMessage: `cancel`,
  },
  CAM_LAYOUT_BTN_CANCEL_PROCEED: {
    id: 'CAM_LAYOUT_BTN_CANCEL_PROCEED',
    defaultMessage: `Are you sure you want to proceed to cancel this session?`,
  },
  CAM_LAYOUT_BTN_CONFIRM_PROCEED: {
    id: 'CAM_LAYOUT_BTN_CONFIRM_PROCEED',
    defaultMessage: `Are you sure you want to proceed to confirm this session?`,
  },
  CAM_CONFIRM_SKIP_TITLE: {
    id: 'CAPTURE_CONFIRM_SKIP_TITLE',
    defaultMessage: `Confirm skip photo capture`,
  },
  CAM_CONFIRM_SKIP_MESSAGE: {
    id: 'CAPTURE_CONFIRM_SKIP_MESSAGE',
    defaultMessage: `Are you sure you want to skip capturing a photo? You won't be able to go back and capture it later. Click "Confirm" to proceed with skipping the photo capture or "Back" to go back and take a photo.`,
  },
  CAM_DENY_SKIP_MESSAGE: {
    id: 'CAM_DENY_SKIP_MESSAGE',
    defaultMessage: `Please capture at least one photo. Skipping is not allowed.`,
  },
  DAMAGES_CONFIRM_DAMAGES_BTN: {
    id: 'DAMAGES_CONFIRM_DAMAGES_BTN',
    defaultMessage: `Confirm`,
  },
  ADD_IMAGES_GALLERY_PRIMARY: {
    id: 'ADD_IMAGES_GALLERY_PRIMARY',
    defaultMessage: `Primary Image`,
  },
  ADD_IMAGES_GALLERY_ADD_MORE: {
    id: 'ADD_IMAGES_GALLERY_ADD_MORE',
    defaultMessage: `Add More`,
  },
  ADD_IMAGES_GALLERY_BTN_UPLOAD_ALL: {
    id: 'ADD_IMAGES_GALLERY_BTN_UPLOAD_ALL',
    defaultMessage: `Upload All`,
  },
  ADD_IMAGES_GALLERY_BTN_BACK: {
    id: 'ADD_IMAGES_GALLERY_BTN_BACK',
    defaultMessage: `Back`,
  },
  ADD_IMAGES_GALLERY_ADD_MORE_CAPTION: {
    id: 'ADD_IMAGES_GALLERY_ADD_MORE_CAPTION',
    defaultMessage: ` Click here to capture or upload additional photos of the vehicle.`,
  },
  ADD_IMAGES_GALLERY_MAX: {
    id: 'ADD_IMAGES_GALLERY_MAX',
    defaultMessage: `Max`,
  },
  ADD_IMAGES_GALLERY_IMAGES: {
    id: 'ADD_IMAGES_GALLERY_IMAGES',
    defaultMessage: `Images`,
  },
  ADD_IMAGES_GALLERY_PRIMARY_CAPTION: {
    id: 'ADD_IMAGES_GALLERY_PRIMARY_CAPTION',
    defaultMessage: `Click here to capture or upload the photo that will be the vehicle’s glamour/primary image.`,
  },
  ADD_IMAGES_GALLERY_UPLOADING_WAIT: {
    id: 'ADD_IMAGES_GALLERY_UPLOADING_WAIT',
    defaultMessage: `Uploading photos, please wait...`,
  },
  DISCLOSURES_ANNOUNCEMENT_2: {
    id: 'DISCLOSURES_ANNOUNCEMENT_2',
    defaultMessage: `Announcements`,
  },
  ANNOUNTCEMENT_TITLE_2: {
    id: 'ANNOUNTCEMENT_TITLE_2',
    defaultMessage: `Please fill out any of the following announcements that apply.`,
  },
  ANNOUNTCEMENT_TITLE_3: {
    id: 'ANNOUNTCEMENT_TITLE_3',
    defaultMessage: `submit announcement`,
  },
  SWIPE_TO_FORCE_FULLSCREEN_BTN: {
    id: 'SWIPE_TO_FORCE_FULLSCREEN_BTN',
    defaultMessage: `skip`,
  },
  DISCLOSURES_ANNOUNCEMENT_1: {
    id: 'DISCLOSURES_ANNOUNCEMENT_1',
    defaultMessage: `Disclosures`,
  },
  DISCLOSURES_TITLE_2: {
    id: 'DISCLOSURES_TITLE_2',
    defaultMessage: `In your jurisdiction you are responsible for the disclosure of any facts you may know about this vehicle, please select any of the following that apply.`,
  },
  DISCLOSURES_TITLE_3: {
    id: 'DISCLOSURES_TITLE_3',
    defaultMessage: `submit disclosures`,
  },
  TABLE_RENDER_YES: {
    id: 'TABLE_RENDER_YES',
    defaultMessage: `YES`,
  },
  TABLE_RENDER_NO: {
    id: 'TABLE_RENDER_NO',
    defaultMessage: `NO`,
  },
  TABLE_RENDER_NA: {
    id: 'TABLE_RENDER_NA',
    defaultMessage: `N/A`,
  },
  DISCLOSURES_TITLE_ORIGIN: {
    id: 'DISCLOSURES_TITLE_ORIGIN',
    defaultMessage: `title_origin`,
  },
  DISCLOSURES_OUT_OF_STATE: {
    id: 'DISCLOSURES_OUT_OF_STATE',
    defaultMessage: `Out of Province`,
  },
  DISCLOSURES_OUT_OF_STATE_DESCRIPTION: {
    id: 'DISCLOSURES_OUT_OF_STATE_DESCRIPTION',
    defaultMessage: `If the province of the last registration (or equivalent) to a retail customer is different than the jurisdiction from which the vehicle is currently being sold, the vehicle must be declared an out of province vehicle and the Seller must identify the last province in which the vehicle was registered (or equivalent) to a retail customer.For vehicles sold in Ontario only:A vehicle remains an out of province vehicle and must be so declared, if it was previously registered (or equivalent) to a retail customer in another province and has been registered in Ontario for less than 7 consecutive years. The Seller must declare all of the provinces in which the vehicle was previously registered.`,
  },
  DISCLOSURES_CROSS_BORDER: {
    id: 'DISCLOSURES_CROSS_BORDER',
    defaultMessage: `Cross Border`,
  },
  DISCLOSURES_CROSS_BORDER_DESCRIPTION: {
    id: 'DISCLOSURES_CROSS_BORDER_DESCRIPTION',
    defaultMessage: `The Seller must declare if the vehicle was ever registered in the  United States or manufactured not in compliance with Canadian standards. All U.S. vehicles offered for sale must include a CarProof Verified vehicle history report or equivalent.`,
  },
  DISCLOSURES_TITLE_BRANCH: {
    id: 'DISCLOSURES_TITLE_BRANCH',
    defaultMessage: `Title Branded`,
  },
  DISCLOSURES_TITLE_BRANCH_DES: {
    id: 'DISCLOSURES_TITLE_BRANCH_DES',
    defaultMessage: `The  Seller must disclose if the vehicle’s title has been branded in accordance with provincial or state law and must indicate the brand(s) assigned.`,
  },
  DISCLOSURES_INCORRECT_VEHICLE_MARKING: {
    id: 'DISCLOSURES_INCORRECT_VEHICLE_MARKING',
    defaultMessage: `Incorrect Vehicle Marking`,
  },
  DISCLOSURES_INCORRECT_VEHICLE_MARKING_DES: {
    id: 'DISCLOSURES_INCORRECT_VEHICLE_MARKING_DES',
    defaultMessage: `The Seller must disclose if any logo, badge, decal, emblem, ornament or similar markings on the vehicle do not match the make, model or series of the vehicle.`,
  },
  DISCLOSURES_STONE_RECOVER: {
    id: 'DISCLOSURES_STONE_RECOVER',
    defaultMessage: `Stolen and Recovered`,
  },
  DISCLOSURES_STONE_RECOVER_DES: {
    id: 'DISCLOSURES_STONE_RECOVER_DES',
    defaultMessage: `The Seller must disclose if a vehicle was recovered after being reported as stolen`,
  },
  DISCLOSURES_WARRANTY_CANCELLED: {
    id: 'DISCLOSURES_WARRANTY_CANCELLED',
    defaultMessage: `Warranty Cancelled`,
  },
  DISCLOSURES_WARRANTY_CANCELLED_DES: {
    id: 'DISCLOSURES_WARRANTY_CANCELLED_DES',
    defaultMessage: `The Seller must disclose if the manufacturer has cancelled the warranty on the Vehicle or has given notice of its intention to do so. Notice of warranty cancellation given after the date of sale is not subject to arbitration.`,
  },
  DISCLOSURES_VIN_PLATE: {
    id: 'DISCLOSURES_VIN_PLATE',
    defaultMessage: `VIN Plate issues`,
  },
  DISCLOSURES_VIN_PLATE_DES: {
    id: 'DISCLOSURES_VIN_PLATE_DES',
    defaultMessage: `The Seller must disclose if the original VIN plate (on the driver’s side of the dashboard) has been removed, altered or replaced. Vehicles may not be offered for sale unless the original VIN plate is intact or has been replaced in accordance with provincial and federal regulatory requirements.`,
  },
  DISCLOSURES_MANUALFACTURER: {
    id: 'DISCLOSURES_MANUALFACTURER',
    defaultMessage: `Manufacturer Repurchase`,
  },
  DISCLOSURES_MANUALFACTURER_DES: {
    id: 'DISCLOSURES_MANUALFACTURER_DES',
    defaultMessage: `The Seller must disclose if the motor vehicle was repurchased by the manufacturer under the Canadian Motor Vehicle Arbitration Plan or under the laws of any jurisdiction including but not limited to  U.S. lemon laws.  If the reasons for, date and/or jurisdiction of the repurchase are known, they should be disclosed.`,
  },
  DISCLOSURES_TOTAL_LOSS: {
    id: 'DISCLOSURES_TOTAL_LOSS',
    defaultMessage: `Total Loss`,
  },
  DISCLOSURES_TOTAL_LOSS_DES: {
    id: 'DISCLOSURES_TOTAL_LOSS_DES',
    defaultMessage: `The Seller must declare if an insurer determined the vehicle was a total loss.`,
  },
  DISCLOSURES_GREY_MARKET: {
    id: 'DISCLOSURES_GREY_MARKET',
    defaultMessage: `Grey Market`,
  },
  DISCLOSURES_GREY_MARKET_DES: {
    id: 'DISCLOSURES_GREY_MARKET_DES',
    defaultMessage: `The Seller must declare if the vehicle was ever registered in a country other than the United States or Canada or manufactured not in compliance with  North  American standards. All Grey market vehicles offered for sale must include a CarProof Verified vehicle history report or equivalent.`,
  },
  DISCLOSURES_ODOMETER_INMILES: {
    id: 'DISCLOSURES_ODOMETER_INMILES',
    defaultMessage: `Odometer in  Miles`,
  },
  DISCLOSURES_ODOMETER_INMILES_DES: {
    id: 'DISCLOSURES_ODOMETER_INMILES_DES',
    defaultMessage: `The Seller must disclose if the odometer is in miles.`,
  },
  DISCLOSURES_ODOMETER_BROKEN: {
    id: 'DISCLOSURES_ODOMETER_BROKEN',
    defaultMessage: `Odometer Broken/Faulty`,
  },
  DISCLOSURES_ODOMETER_BROKEN_DES: {
    id: 'DISCLOSURES_ODOMETER_BROKEN_DES',
    defaultMessage: `The Seller must disclose if the odometer of the vehicle is broken or faulty, i.e. not accurately tracking distance driven.`,
  },
  DISCLOSURES_ODOMETER_REPLACE: {
    id: 'DISCLOSURES_ODOMETER_REPLACE',
    defaultMessage: `Odometer Replaced`,
  },
  DISCLOSURES_ODOMETER_REPLACE_DES: {
    id: 'DISCLOSURES_ODOMETER_REPLACE_DES',
    defaultMessage: `The Seller must disclose if the odometer has been replaced.`,
  },
  DISCLOSURES_ODOMETER_ROLL: {
    id: 'DISCLOSURES_ODOMETER_ROLL',
    defaultMessage: `Odometer Roll Back`,
  },
  DISCLOSURES_ODOMETER_ROLL_DES: {
    id: 'DISCLOSURES_ODOMETER_ROLL_DES',
    defaultMessage: `The Seller must disclose if the odometer has been rolled back.`,
  },
  DISCLOSURES_UNREADABLE: {
    id: 'DISCLOSURES_UNREADABLE',
    defaultMessage: `Odometer Unreadable`,
  },
  DISCLOSURES_UNREADABLE_DES: {
    id: 'DISCLOSURES_UNREADABLE_DES',
    defaultMessage: `The Seller must declare the odometer to be unreadable if it is accurately tracking distance driven but cannot be read due to  pixel damage, because the vehicle cannot be started to obtain an odometer reading or similar reasons.`,
  },
  DISCLOSURES_TRUE_KILOMETER: {
    id: 'DISCLOSURES_TRUE_KILOMETER',
    defaultMessage: `True Kilometers Unknown`,
  },
  DISCLOSURES_TRUE_KILOMETER_DES: {
    id: 'DISCLOSURES_TRUE_KILOMETER_DES',
    defaultMessage: `The Seller must declare a vehicle TKU (true kilometres unknown) if the distance travelled is unknown and there are no reliable records available to verify the odometer reading as of a certain date.  When a vehicle is declared TKU, the total distance that a vehicle has been driven is likely substantially higher than the reading shown on the odometer.`,
  },
  DISCLOSURES_RECENT_KILOMETER: {
    id: 'DISCLOSURES_RECENT_KILOMETER',
    defaultMessage: `Recent Kilometers Unknown`,
  },
  DISCLOSURES_RECENT_KILOMETER_DES: {
    id: 'DISCLOSURES_RECENT_KILOMETER_DES',
    defaultMessage: `If the total distance driven is unknown, but based on reliable records, the distance driven as of a certain date is known, the Seller must declare the last known distance and provide the date.`,
  },
  DISCLOSURES_ODOMETER_5_DIGITS: {
    id: 'DISCLOSURES_ODOMETER_5_DIGITS',
    defaultMessage: `Odometer has Only 5 Digits`,
  },
  DISCLOSURES_ODOMETER_5_DIGITS_DES: {
    id: 'DISCLOSURES_ODOMETER_5_DIGITS_DES',
    defaultMessage: `The Seller must disclose if the odometer is a 5 digit odometer with over 100,000 miles or kilometers.`,
  },
  DISCLOSURES_ACCIDENT_REPAIR: {
    id: 'DISCLOSURES_ACCIDENT_REPAIR',
    defaultMessage: `Accident Repair`,
  },
  DISCLOSURES_ACCIDENT_REPAIR_DES: {
    id: 'DISCLOSURES_ACCIDENT_REPAIR_DES',
    defaultMessage: `The Seller must declare a Vehicle to be Accident Repaired if the total cost to fix the damage caused by a single incident was $3,000 or more ($2,000 cumulative incidents in British Columbia).The Accident Repair declaration must be made regardless of whether the damage was caused by collision, accident, weather or by some other incident. If the dollar value of the repair is known, it must be declared. If the Accident Repair information comes from a vehicle history report and the Seller believes that the Vehicle History Report is incorrect, it is the Seller’s obligation to get the report corrected within the Arbitration period or risk having the sale cancelled. Although not required, if the Seller chooses to declare an Accident Repair under $3,000 ($2,000 cumulative in B.C.), it may do so separately as an additional disclosure. Arbitration is not allowed for repairs under $3,000 ($2,000 cumulative in British Columbia).`,
  },
  DISCLOSURES_ADJACENT_PANELS: {
    id: 'DISCLOSURES_ADJACENT_PANELS',
    defaultMessage: `Adjacent Panels Replaced`,
  },
  DISCLOSURES_ADJACENT_PANELS_DES: {
    id: 'DISCLOSURES_ADJACENT_PANELS_DES',
    defaultMessage: `The Seller must declare if two or more adjacent panels (excluding bumper panels) have been replaced on a vehicle. Please note: If the panels were replaced due to an accident or another incident, depending on the cost of the repairs, it may also be necessary for the Seller to make the Accident Repair declaration.`,
  },
  DISCLOSURES_EXCESSIVE_RUST: {
    id: 'DISCLOSURES_EXCESSIVE_RUST',
    defaultMessage: `Excessive Rust`,
  },
  DISCLOSURES_EXCESSIVE_RUST_DES: {
    id: 'DISCLOSURES_EXCESSIVE_RUST_DES',
    defaultMessage: `The Seller must disclose if the vehicle suffers from excessive rust. Rust is considered to be excessive when the location or quantity of the rust affects the structural integrity of the vehicle, e.g. the frame or any structural component is perforated by rust.`,
  },
  DISCLOSURES_STRUCTURAL_DAMAGES: {
    id: 'DISCLOSURES_STRUCTURAL_DAMAGES',
    defaultMessage: `Structural Damage`,
  },
  DISCLOSURES_STRUCTURAL_DAMAGES_DES: {
    id: 'DISCLOSURES_STRUCTURAL_DAMAGES_DES',
    defaultMessage: `The Seller must declare a vehicle to have structural damage if it meets the definition of structural damage set out in the National Auto Auction Association’s Structural Damage Policy.  See www.naaa.com`,
  },
  DISCLOSURES_FLOOD_DAMAGES: {
    id: 'DISCLOSURES_FLOOD_DAMAGES',
    defaultMessage: `Flood Damage`,
  },
  DISCLOSURES_FLOOD_DAMAGE_DES: {
    id: 'DISCLOSURES_FLOOD_DAMAGE_DES',
    defaultMessage: `The Seller must declare a vehicle as Flood Damaged when: i) water or other liquid has penetrated the vehicle to the level of the floorboards or higher; or ii) if any of the following components have been damaged due to immersion: Front or rear lighting or wiring harnesses, Engine and its major components, Transmission and differential, Dash instrument panel and wiring, Passenger seat cushions, Power seat or window motor, Major sound system components.`,
  },
  DISCLOSURES_FIRE_DAMAGE: {
    id: 'DISCLOSURES_FIRE_DAMAGE',
    defaultMessage: `Fire Damage`,
  },
  DISCLOSURES_FIRE_DAMAGE_DES: {
    id: 'DISCLOSURES_FIRE_DAMAGE_DES',
    defaultMessage: `The Seller must disclose if the vehicle has been damaged by fire.`,
  },
  DISCLOSURES_IRREPARABLE: {
    id: 'DISCLOSURES_IRREPARABLE',
    defaultMessage: `Irreparable`,
  },
  DISCLOSURES_IRREPARABLE_DES: {
    id: 'DISCLOSURES_IRREPARABLE_DES',
    defaultMessage: `Regardless of whether the title has been branded, the Seller must disclose if the vehicle is not capable of being repaired for roadworthy operation and may only be used for parts or scrap.  Irreparable vehicles are assumed to also be Total Loss vehicles and thus the Total Loss declaration does not need to be made.`,
  },
  DISCLOSURES_AIR_BAGS: {
    id: 'DISCLOSURES_AIR_BAGS',
    defaultMessage: `Air Bags Missing/Defective`,
  },
  DISCLOSURES_AIR_BAGS_DES: {
    id: 'DISCLOSURES_AIR_BAGS_DES',
    defaultMessage: `The Seller must disclose if the vehicle’s airbags are missing or not operational.`,
  },
  DISCLOSURES_MAJOR_REPAIR: {
    id: 'DISCLOSURES_MAJOR_REPAIR',
    defaultMessage: `Major Repair Needed`,
  },
  DISCLOSURES_MAJOR_REPAIR_DES: {
    id: 'DISCLOSURES_MAJOR_REPAIR_DES',
    defaultMessage: ` The Seller must disclose if a major component of the vehicle is defective or not operational and the component would cost over $750 (on a non-cumulative basis) to repair or replace in accordance with standard Mitchell warranty rates. Major components include: Engine, Transmission, Power train, Sub‐frame, Suspension, Computer equipment, Fuel operating system, Electrical system, Emissions system, Air Conditioning, Hail damage. The following items are not subject to arbitration: Upholstery, Glass, Tires, Visible body damage.`,
  },
  DISCLOSURES_MATERIAL_VARIATION: {
    id: 'DISCLOSURES_MATERIAL_VARIATION',
    defaultMessage: `Material Variation from Production Specs`,
  },
  DISCLOSURES_MATERIAL_VARIATION_DES: {
    id: 'DISCLOSURES_MATERIAL_VARIATION_DES',
    defaultMessage: `The Seller must disclose if the vehicle varies materially from the original manufacturer’s specifications.`,
  },
  DISCLOSURES_ABS: {
    id: 'DISCLOSURES_ABS',
    defaultMessage: `ABS Defective`,
  },
  DISCLOSURES_ABS_DES: {
    id: 'DISCLOSURES_ABS_DES',
    defaultMessage: `The Seller must disclose if the anti‐lock braking system is not operational (if equipped). Arbitration is only available for repairs over $750 (standard Mitchell warranty rates).`,
  },
  DISCLOSURES_ALTERNATE_FUEL: {
    id: 'DISCLOSURES_ALTERNATE_FUEL',
    defaultMessage: `Alternate Fuel or Conversion`,
  },
  DISCLOSURES_ALTERNATE_FUEL_DES: {
    id: 'DISCLOSURES_ALTERNATE_FUEL_DES',
    defaultMessage: `The Seller must disclose if the vehicle uses propane or natural gas, or at any time had a propane or natural gas fuel system.`,
  },
  DISCLOSURES_PREVIOUS_DAILY: {
    id: 'DISCLOSURES_PREVIOUS_DAILY',
    defaultMessage: `Previous Daily Rental`,
  },
  DISCLOSURES_PREVIOUS_DAILY_DES: {
    id: 'DISCLOSURES_PREVIOUS_DAILY_DES',
    defaultMessage: `The Seller must disclose if the vehicle was previously used as a daily rental vehicle (unless the vehicle was subsequently owned by a non‐dealer).`,
  },
  DISCLOSURES_TAXI_LIMO: {
    id: 'DISCLOSURES_TAXI_LIMO',
    defaultMessage: `Previous Taxi/Limo`,
  },
  DISCLOSURES_TAXI_LIMO_DES: {
    id: 'DISCLOSURES_TAXI_LIMO_DES',
    defaultMessage: `The Seller must disclose if the vehicle was previously used as a taxi or limousine.`,
  },
  DISCLOSURES_PREVIOUS_DRIVING_SCHOOL: {
    id: 'DISCLOSURES_PREVIOUS_DRIVING_SCHOOL',
    defaultMessage: `Previous Driving School Vehicle`,
  },
  DISCLOSURES_PREVIOUS_DRIVING_SCHOOL_DES: {
    id: 'DISCLOSURES_PREVIOUS_DRIVING_SCHOOL_DES',
    defaultMessage: `The Seller must disclose if the vehicle was previously used as a driving school vehicle.`,
  },
  DISCLOSURES_POLICE_VEHICLE: {
    id: 'DISCLOSURES_POLICE_VEHICLE',
    defaultMessage: `Previous Police Vehicle`,
  },
  DISCLOSURES_POLICE_VEHICLE_DES: {
    id: 'DISCLOSURES_POLICE_VEHICLE_DES',
    defaultMessage: `The Seller must disclose if the vehicle was previously used as a police cruiser.`,
  },
  DISCLOSURES_EMERGENCY_SERVICE: {
    id: 'DISCLOSURES_EMERGENCY_SERVICE',
    defaultMessage: `Previous Emergency Services Vehicle`,
  },
  DISCLOSURES_EMERGENCY_SERVICE_DES: {
    id: 'DISCLOSURES_EMERGENCY_SERVICE_DES',
    defaultMessage: `The Seller must disclose if the vehicle was previously used as an emergency services vehicle.`,
  },
  DISCLOSURES_TITLE_PRESENT: {
    id: 'DISCLOSURES_TITLE_PRESENT',
    defaultMessage: `Title or Ownership Documents Present?`,
  },
  DISCLOSURES_TITLE_PRESENT_DES: {
    id: 'DISCLOSURES_TITLE_PRESENT_DES',
    defaultMessage: `The Seller must announce if the vehicle title is present and in the Sellers name.`,
  },
  DISCLOSURES_ALL_KEY: {
    id: 'DISCLOSURES_ALL_KEY',
    defaultMessage: `All Keys Are Present?`,
  },
  DISCLOSURES_ALL_KEY_DES: {
    id: 'DISCLOSURES_ALL_KEY_DES',
    defaultMessage: `The Seller must announce if all the original keys and fobs are present.`,
  },
  DISCLOSURES_BOOKS_PRESENT: {
    id: 'DISCLOSURES_BOOKS_PRESENT',
    defaultMessage: `Are all Service, Warranty and Owner’s Manuals present?`,
  },
  DISCLOSURES_BOOKS_PRESENT_DES: {
    id: 'DISCLOSURES_BOOKS_PRESENT_DES',
    defaultMessage: `The Seller must announce if all original books are present.`,
  },
  DISCLOSURES_DISC_PRESENTS: {
    id: 'DISCLOSURES_DISC_PRESENTS',
    defaultMessage: `All Software and Navigation Discs Are Present?`,
  },
  DISCLOSURES_DISC_PRESENTS_DES: {
    id: 'DISCLOSURES_DISC_PRESENTS_DES',
    defaultMessage: `The Seller must announce if all of the original software and navigation discs are present`,
  },
  DISCLOSURES_RIM_TIRES: {
    id: 'DISCLOSURES_RIM_TIRES',
    defaultMessage: `If Aftermarket/Winter Tires and Rims, Are Originals Included?`,
  },
  DISCLOSURES_RIM_TIRES_DES: {
    id: 'DISCLOSURES_RIM_TIRES_DES',
    defaultMessage: `The Seller has the option to include the original rims and tires that came with the vehicle`,
  },
  DISCLOSURES_ANY_ORHER: {
    id: 'DISCLOSURES_ANY_ORHER',
    defaultMessage: `Any Other Announcements?`,
  },
  DISCLOSURES_ANY_ORHER_DES: {
    id: 'DISCLOSURES_ANY_ORHER_DES',
    defaultMessage: `The Seller has the option to include additional infromation about the vehicle.`,
  },
  DISCLOSURES_FRONT_OR: {
    id: 'DISCLOSURES_FRONT_OR',
    defaultMessage: `Front or rear lighting or wiring harnesses`,
  },
  DISCLOSURES_ENGINE_IT_MAJOR: {
    id: 'DISCLOSURES_ENGINE_IT_MAJOR',
    defaultMessage: `Engine and its major components`,
  },
  DISCLOSURES_TRANSMISSION_DIFFERENTIAL: {
    id: 'DISCLOSURES_TRANSMISSION_DIFFERENTIAL',
    defaultMessage: `Transmission and differential`,
  },
  DISCLOSURES_DASH_INSTRUMENT: {
    id: 'DISCLOSURES_DASH_INSTRUMENT',
    defaultMessage: `Dash instrument panel and wiring`,
  },
  DISCLOSURES_PASSENGER_SEAT: {
    id: 'DISCLOSURES_PASSENGER_SEAT',
    defaultMessage: `Passenger seat cushions`,
  },
  DISCLOSURES_POWER_SEAT_WINDOW: {
    id: 'DISCLOSURES_POWER_SEAT_WINDOW',
    defaultMessage: `Power seat or window motor`,
  },
  DISCLOSURES_MAJOR_SOUND_SYSTEM: {
    id: 'DISCLOSURES_MAJOR_SOUND_SYSTEM',
    defaultMessage: `Major sound system components`,
  },
  DISCLOSURES_LIST_MAJOR_1: {
    id: 'DISCLOSURES_LIST_MAJOR_1',
    defaultMessage: `Engine`,
  },
  DISCLOSURES_LIST_MAJOR_2: {
    id: 'DISCLOSURES_LIST_MAJOR_2',
    defaultMessage: `Transmission`,
  },
  DISCLOSURES_LIST_MAJOR_3: {
    id: 'DISCLOSURES_LIST_MAJOR_3',
    defaultMessage: `Powertrain`,
  },
  DISCLOSURES_LIST_MAJOR_4: {
    id: 'DISCLOSURES_LIST_MAJOR_4',
    defaultMessage: `Sub-­frame`,
  },
  DISCLOSURES_LIST_MAJOR_5: {
    id: 'DISCLOSURES_LIST_MAJOR_5',
    defaultMessage: `Suspension`,
  },
  DISCLOSURES_LIST_MAJOR_6: {
    id: 'DISCLOSURES_LIST_MAJOR_6',
    defaultMessage: `Computer equipment`,
  },
  DISCLOSURES_LIST_MAJOR_7: {
    id: 'DISCLOSURES_LIST_MAJOR_7',
    defaultMessage: `Fuel operating system`,
  },
  DISCLOSURES_LIST_MAJOR_8: {
    id: 'DISCLOSURES_LIST_MAJOR_8',
    defaultMessage: `Electrical system`,
  },
  DISCLOSURES_LIST_MAJOR_9: {
    id: 'DISCLOSURES_LIST_MAJOR_9',
    defaultMessage: `Emissions system`,
  },
  DISCLOSURES_LIST_MAJOR_10: {
    id: 'DISCLOSURES_LIST_MAJOR_10',
    defaultMessage: `Air Conditioning`,
  },
  DISCLOSURES_LIST_MAJOR_11: {
    id: 'DISCLOSURES_LIST_MAJOR_11',
    defaultMessage: `Hail damage`,
  },
  DAMAGES_NO_DAMAGES_DETECTED: {
    id: 'DAMAGES_NO_DAMAGES_DETECTED',
    defaultMessage: `No Damage Detected`,
  },
  DAMAGES_UPDATED_DAMAGES: {
    id: 'DAMAGES_UPDATED_DAMAGES',
    defaultMessage: `Update`,
  },
  DAMAGES_BTN_ADD_DAMAGES: {
    id: 'DAMAGES_BTN_ADD_DAMAGES',
    defaultMessage: `Add damages`,
  },
  SMS_MESSAGES_BTN_1: {
    id: 'SMS_MESSAGES_BTN_1',
    defaultMessage: `Enter your cell phone number to receive an SMS with your link when your inspection is complete.`,
  },
  SMS_MESSAGES_BTN_3: {
    id: 'SMS_MESSAGES_BTN_3',
    defaultMessage: `save`,
  },
  DAMAGES_FORM_INPUT_2: {
    id: 'DAMAGES_FORM_INPUT_2',
    defaultMessage: `Odometer Type`,
  },
  DAMAGES_FORM_INPUT_3: {
    id: 'DAMAGES_FORM_INPUT_3',
    defaultMessage: `EXT. COLOUR`,
  },
  DAMAGES_FORM_INPUT_5: {
    id: 'DAMAGES_FORM_INPUT_5',
    defaultMessage: `Body Style`,
  },
  DAMAGES_FORM_INPUT_7: {
    id: 'DAMAGES_FORM_INPUT_7',
    defaultMessage: `Displacement`,
  },
  DAMAGES_FORM_INPUT_8: {
    id: 'DAMAGES_FORM_INPUT_8',
    defaultMessage: `Drivetrain`,
  },
  DAMAGES_FORM_INPUT_9: {
    id: 'DAMAGES_FORM_INPUT_9',
    defaultMessage: `Int. Colour`,
  },
  DAMAGES_FORM_INPUT_10: {
    id: 'DAMAGES_FORM_INPUT_10',
    defaultMessage: `Fuel`,
  },
  FINAL_REPORT_1: {
    id: 'FINAL_REPORT_1',
    defaultMessage: `Condition Report`,
  },
  FINAL_REPORT_2: {
    id: 'FINAL_REPORT_2',
    defaultMessage: `Close`,
  },
  CAMERA_INSTRUCTION_TUTS_1: {
    id: 'CAMERA_INSTRUCTION_TUTS_1',
    defaultMessage: `Kindly Turn On  : Screen Rotation / Location (Optional) to unlock Pave`,
  },
  CAMERA_INSTRUCTION_TUTS_2: {
    id: 'CAMERA_INSTRUCTION_TUTS_2',
    defaultMessage: `Check if Camera / Location (Optional) are Allowed For Your Browser and Device Settings to Use PAVE`,
  },
  CAMERA_INSTRUCTION_TUTS_3: {
    id: 'CAMERA_INSTRUCTION_TUTS_3',
    defaultMessage: `Please make sure that you unlocked these settings in your device settings and your browser settings.`,
  },
  LITE_FINALIZING_SESSION: {
    id: 'LITE_FINALIZING_SESSION',
    defaultMessage: `finalizing session`,
  },
  DISCLOSURES_PLACEHOLDER_0: {
    id: 'DISCLOSURES_PLACEHOLDER_0',
    defaultMessage: `Repair Total`,
  },
  DISCLOSURES_PLACEHOLDER_1: {
    id: 'DISCLOSURES_PLACEHOLDER_1',
    defaultMessage: `Mileage`,
  },
  DISCLOSURES_PLACEHOLDER_2: {
    id: 'DISCLOSURES_PLACEHOLDER_2',
    defaultMessage: `Type Answer Here...`,
  },
  DISCLOSURES_PLACEHOLDER_3: {
    id: 'DISCLOSURES_PLACEHOLDER_3',
    defaultMessage: `Date`,
  },
  DISCLOSURES_PLACEHOLDER_4: {
    id: 'DISCLOSURES_PLACEHOLDER_4',
    defaultMessage: `Year(s) from 1 to 25`,
  },
  DISCLOSURES_PLACEHOLDER_5: {
    id: 'DISCLOSURES_PLACEHOLDER_5',
    defaultMessage: `Input Dollar Amount`,
  },
  SMS_PLACEHOLDER: {
    id: 'SMS_PLACEHOLDER',
    defaultMessage: `Phone number ...`,
  },
  TUTS_INSTRUCTIONS_1: {
    id: 'TUTS_INSTRUCTIONS_1',
    defaultMessage: `Kindly Turn On  : Screen Rotation / Location (Optional) to unlock Pave`,
  },
  TUTS_INSTRUCTIONS_2: {
    id: 'TUTS_INSTRUCTIONS_2',
    defaultMessage: `Check if Camera / Location (Optional) are allowed to Pave`,
  },
  TUTS_INSTRUCTIONS_3: {
    id: 'TUTS_INSTRUCTIONS_3',
    defaultMessage: `Reassure you already Unlocked these Setting in your Device also.`,
  },

  LABEL_1: {
    id: 'LABEL_1',
    defaultMessage: `VIN`,
  },
  PAVE_DAMS_GROUP_TITLE: {
    id: 'PAVE_DAMS_GROUP_TITLE',
    defaultMessage: `interior`,
  },
  DAMAGES_FORM_INPUT_1: {
    id: 'DAMAGES_FORM_INPUT_1',
    defaultMessage: `odometer`,
  },
  LABEL_5: {
    id: 'LABEL_5',
    defaultMessage: `front driver quarter angle`,
  },
  LABEL_6: {
    id: 'LABEL_6',
    defaultMessage: `front view `,
  },
  LABEL_7: {
    id: 'LABEL_7',
    defaultMessage: `front passenger quarter angle`,
  },
  ADD_DAMAGES_VIEW_RIGHT: {
    id: 'ADD_DAMAGES_VIEW_RIGHT',
    defaultMessage: `passenger side`,
  },
  LABEL_9: {
    id: 'LABEL_9',
    defaultMessage: `rear passenger quarter angle`,
  },
  PAVE_DAMS_GROUP_TITLE_4: {
    id: 'PAVE_DAMS_GROUP_TITLE_4',
    defaultMessage: `rear view`,
  },
  LABEL_11: {
    id: 'LABEL_11',
    defaultMessage: `rear driver quarter angle`,
  },
  PAVE_DAMS_GROUP_TITLE_5: {
    id: 'PAVE_DAMS_GROUP_TITLE_5',
    defaultMessage: `windshield`,
  },
  LABEL_13: {
    id: 'LABEL_13',
    defaultMessage: `tire`,
  },
  LABEL_15: {
    id: 'LABEL_15',
    defaultMessage: `rear tire`,
  },
  ADD_DAMAGES_VIEW_LEFT: {
    id: 'ADD_DAMAGES_VIEW_LEFT',
    defaultMessage: `driver side`,
  },
  ADD_DAMAGES_VIEW_FRONT: {
    id: 'ADD_DAMAGES_VIEW_FRONT',
    defaultMessage: `front`,
  },
  ADD_DAMAGES_VIEW_REAR: {
    id: 'ADD_DAMAGES_VIEW_REAR',
    defaultMessage: `rear`,
  },
  EXTERIOR_UPDATED_FIRST: {
    id: 'EXTERIOR_UPDATED_FIRST',
    defaultMessage: `Please update your Exterior Damage first`,
  },
  ANNOUNCEMENT_ALL_KEYS_PRESENTS: {
    id: 'ANNOUNCEMENT_ALL_KEYS_PRESENTS',
    defaultMessage: `Number of keys`,
  },
  HOME_NEW_UI_CAPTION: {
    id: 'HOME_NEW_UI_CAPTION',
    defaultMessage: `Collect the vehicle's information and condition in minutes, by just taking 13 photos`,
  },
  HOME_NEW_UI_CAPTION_SLIDE_1: {
    id: 'HOME_NEW_UI_CAPTION_SLIDE_1',
    defaultMessage: `Unlock your display mode to allow your screen to rotate automatically`,
  },
  HOME_NEW_UI_CAPTION_SLIDE_2: {
    id: 'HOME_NEW_UI_CAPTION_SLIDE_2',
    defaultMessage: `Park the vehicle where you have 10-feet/3-meters of space to walk around safely`,
  },
  HOME_NEW_UI_CAPTION_SLIDE_3: {
    id: 'HOME_NEW_UI_CAPTION_SLIDE_3',
    defaultMessage: `Check if camera access is enabled in your settings`,
  },
  HOME_NEW_UI_CAPTION_VIN: {
    id: 'HOME_NEW_UI_CAPTION_VIN',
    defaultMessage: `Capture VIN`,
  },
  HOME_NEW_UI_CAPTION_VIN_1: {
    id: 'HOME_NEW_UI_CAPTION_VIN_1',
    defaultMessage: `Take a photo of your VIN to fetch the vehicle information in seconds.`,
  },
  SELECT_AN_OPTION: {
    id: 'SELECT_AN_OPTION',
    defaultMessage: `select an option`,
  },
  ANNOUNCEMENT_TITLE: {
    id: 'ANNOUNCEMENT_TITLE',
    defaultMessage: `title`,
  },
  ANNOUNCEMENT_KEYS: {
    id: 'ANNOUNCEMENT_KEYS',
    defaultMessage: `keys`,
  },
  ANNOUNCEMENT_DISCS: {
    id: 'ANNOUNCEMENT_DISCS',
    defaultMessage: `discs`,
  },
  ANNOUNCEMENT_TIRES: {
    id: 'ANNOUNCEMENT_TIRES',
    defaultMessage: `tires`,
  },
  ANNOUNCEMENT_OTHER: {
    id: 'ANNOUNCEMENT_OTHER',
    defaultMessage: `other`,
  },
  ANNOUNCEMENT_BOOKS: {
    id: 'ANNOUNCEMENT_BOOKS',
    defaultMessage: `book`,
  },
  QUESTION_VEHICLE_TYPE: {
    id: 'QUESTION_VEHICLE_TYPE',
    defaultMessage: `Vehicle Type`,
  },
});
export default translationsComponents;
